/**
 * @generated SignedSource<<f175f27c6e77082ead9c441bc1bfd1d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureEnum = "AccidentManagement" | "AccidentTowTransfer" | "AddDriverNameonInvoice" | "AddPartnerColumntoFleetManaged" | "AlertCompleteConfirmation" | "AlertDelayedDispatch" | "AlertETAExpiry" | "AlertIncompleteDrafts" | "AlertManualDispatch" | "AlertProactiveETAThreshold" | "AlertReleaseRequired" | "AlertScreenPops" | "AlertServiceRecovery" | "AllowInvoiceAddItem" | "AllowOONDispatchforNotCoveredJobs" | "AlternateRideRequest" | "AutoAssign" | "AutoAssignDriver" | "AutoAssignPAMode" | "AutoComplete" | "AutoOnSite" | "AutoSelectSitefromLookup" | "CanadianAP" | "ClassTypeRequired" | "ClientAPICoverageOverride" | "ClientAPICoverageOverridewithProgram" | "ClientAPICoverageRequired" | "ClientChat" | "ClientProgramAutoSelect" | "ClientSites" | "ComplianceAutoAssign" | "ComplianceManualAssign" | "CreditCardCollection" | "CustomStatementDescriptor" | "CustomerPaymentCollection" | "CustomerPays" | "CustomerRatesIntegration" | "CustomerViewCoBranding" | "DepartmentFilter" | "Departments" | "DirectMobileWeb" | "DirectMobileWebinBrowser" | "DisableAppCreateJobs" | "DisableAppDriversCreateJobs" | "DisableAppDriversEditJobs" | "DisableAppEditJobs" | "DisableBankSettings" | "DisableCommunicationIntegration" | "DisableDeleteJob" | "DisableForcePhotos" | "DisableLicenseRestrictions" | "DisableMobileVINLookup" | "DisableReferralTowDestinationRecommendations" | "DisableSelfServicePayments" | "Disabledrivereditinvoice" | "Disabledriverviewinvoice" | "Disableforceserviceresolution" | "Disableuseremailnotifications" | "DispatchRobocalls" | "Dontrequirecustomernameandphone" | "ETARange" | "EnableDashesforPolicyNumber" | "ExclusivePartner" | "FlatRateTow" | "FleetServiceMap" | "Hide4WD" | "HideLocationContacts" | "HidePartnerETA" | "HideReporting" | "InternationalPhoneNumbers" | "InvoiceCustomItems" | "InvoiceWarning" | "Invoices" | "Invoicing" | "Issues" | "JobFormAuthorizeRequesthiddenforPreDraft" | "JobFormClaimNumber" | "JobFormClientAuthorizationforPartiallyCovered" | "JobFormClientAuthorizations" | "JobFormClientAuthorizationsforRVandMotorcycle" | "JobFormCopyProfilePhoneNumber" | "JobFormCoverage" | "JobFormCustomerLookup" | "JobFormDowntimeProgramHandling" | "JobFormEmailField" | "JobFormEmailFieldRequired" | "JobFormEnableClientCompanyUserClientAuthorization" | "JobFormLicensePlateFieldRequired" | "JobFormOdometerRequired" | "JobFormPONumberRequired" | "JobFormPolicyNumber" | "JobFormPolicyNumberPartialSearch" | "JobFormPolicyNumberRequired" | "JobFormPolicyRequiredforClientAuthorizations" | "JobFormProgramSelection" | "JobFormRecommendedDropOff" | "JobFormRestrictedSupervisorAuthorizationReasons" | "JobFormServiceContractRequiredforAuthorizations" | "JobFormSiteRequired" | "JobFormSupervisorAuthorizations" | "JobFormTowDestinationApproval" | "JobFormTowDestinationPriority" | "JobFormUnitRequired" | "JobFormValidVINRequiredforClientAuthorizations" | "JobFormValidVINRequiredforSupervisorAuthorizations" | "JobMemberNumber" | "JobMemberNumberRequired" | "JobPONumber" | "JobPriorityResponseProfileAutoSelect" | "JobReferenceNumber" | "JobSubclientCode" | "JobUnitNumber" | "LocationContacts" | "Looker" | "MCJobAutoRejectOverride" | "ManualAssignAccidentTowPFallback" | "ManualAssignDispatchablePartnersOnly" | "ManualAssignOONDispatch" | "MobileWebIntake" | "MobileWebIntakeManualEntryOnly" | "MobileWebIntakeStandardSymptoms" | "MultiFactorAuthentication" | "NPSExternalSurveyRedirectEnabled" | "POOnDashboard" | "PartialFeesFlatRateorEnRouteMiles" | "PartnerDispatchtoTruck" | "PaymentType" | "PlaneAnimation" | "PostNPSWinback" | "PreNPSWinback" | "PreventJobDispatch" | "PriorityResponse" | "ProviderInvoicesRestrictAddOns" | "ProviderReferral" | "PublicMobileWeb" | "PublicMobileWebinBrowser" | "Questions" | "ReferredtoCanceledClientAPIMask" | "Removeinvoicetimestampsperaccount" | "RepairAdvantageTowCoupons" | "Review4Texts" | "ReviewChoose" | "ReviewFeed" | "ReviewNPSMobileWeb" | "ReviewNPSQ1SMS" | "ReviewPureNPS" | "ReviewsFeedQ1Filter" | "SMSConfirmComplete" | "SMSConfirmOnSite" | "SMSDraftFollowUp" | "SMSRelativeETA" | "SMSRequestLocation" | "SMSReviews" | "SMSTireChangeSafety" | "SMSUpdates" | "SMSVerifyStatus" | "SSOFallback" | "SerialNumber" | "Settings" | "ShareableSites" | "ShowClientSitestoSwoop" | "ShowCustomerPaymentInfo" | "ShowETAonmobilejobdetails" | "ShowSymptoms" | "ShowVehicleSubTypeField" | "SingleSignOn" | "SingularReferralTowDestination" | "Storage" | "StorageManagement" | "SwoopRootAllVehicleUpdates" | "TaskManagement" | "TelephonyIntegration" | "Uber" | "UnlistedTrailerQuestion" | "UnlistedVehicleApplyEventLimits" | "UnlistedVehicleOption" | "UnlistedVehicleOwnerPassengerQuestion" | "UnpaidtoDraftClientAPIMask" | "VIP" | "VehicleConditionQuestions" | "ViewOnlyClient";
export type useFeaturesEnabledQuery$variables = {
  companyId: string;
};
export type useFeaturesEnabledQuery$data = {
  readonly node: {
    readonly features?: {
      readonly nodes: ReadonlyArray<{
        readonly key: FeatureEnum;
      }>;
    } | null;
  } | null;
};
export type useFeaturesEnabledQuery = {
  response: useFeaturesEnabledQuery$data;
  variables: useFeaturesEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 300
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFeaturesEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "FeatureConnection",
                "kind": "LinkedField",
                "name": "features",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Feature",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "features(first:300)"
              }
            ],
            "type": "Company",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeaturesEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "FeatureConnection",
                "kind": "LinkedField",
                "name": "features",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Feature",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "features(first:300)"
              }
            ],
            "type": "Company",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be6168155f8ccaa35d1f9b5c8345a7c0",
    "id": null,
    "metadata": {},
    "name": "useFeaturesEnabledQuery",
    "operationKind": "query",
    "text": "query useFeaturesEnabledQuery(\n  $companyId: ID!\n) {\n  node(id: $companyId) {\n    __typename\n    ... on Company {\n      features(first: 300) {\n        nodes {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ce7b1dff18b6900086b2b2c8508fae5";

export default node;
